import { Component, Input } from '@angular/core';
import { IItemWishList } from 'src/app/shared/interfaces/custom-item-wish-list';

@Component({
  selector: 'app-custom-item-card-image-wish-list',
  templateUrl: './custom-item-card-image-wish-list.component.html'
})
export class CustomItemCardImageWishListComponent {

  @Input() product: IItemWishList = new IItemWishList;
  constructor(){}
}
